import type { FC } from 'react';
import React from 'react';

import type { TFio } from './models';

export const Fio: FC<TFio> = ({ FioThreeField, OneFieldFio, oneFieldFio, ...rest }) =>
    oneFieldFio ? (
        <OneFieldFio {...rest} />
    ) : (
        <FioThreeField
            genderTagsSize="xs"
            name={{
                lastName: 'lastName',
                firstName: 'firstName',
                middleName: 'middleName',
                gender: 'sex',
            }}
            settings={rest.settings}
            styler={{ marginBottom: 24 }}
        />
    );
